import axios from "axios";
import { dispatch } from "../store";
import { ErrorButtonHandler } from "./ErrorButtonHandler";

const initModalState = {
    message: null,
    buttons: [new ErrorButtonHandler("Cancel", () => dispatch.modal.clear())],
};


let base_url;
if (process.env.NODE_ENV === "production") {

    base_url = process.env.REACT_APP_PROD_URL;

} else if (process.env.NODE_ENV === "development") {
    base_url = process.env.REACT_APP_DEV_URL;

}
else {
    
    base_url = process.env.REACT_APP_STAGING_URL;
}




axios.defaults.baseURL = base_url;
axios.defaults.headers.common["x-api-key"] = process.env.REACT_APP_API_KEY;

axios.interceptors.request.use((config) => {
    return config;
});

axios.interceptors.response.use(
    (response) => {
        let responseData = response.data;
        if (
            responseData.responseCode === "00" ||
            responseData.responseCode === "01" ||
            (responseData.responseCode !== "00" && responseData.responseData !== null)
        ) {
            return responseData.responseData;
        }

        if (responseData.responseCode !== "97")
            dispatch.modal.toggle({
                message: responseData.responseMessage,
                buttons: [
                    new ErrorButtonHandler("Cancel", () => dispatch.modal.clear()),
                ],
            });
        return Promise.reject(responseData.responseMessage);
    },

    (error) => {
        dispatch.modal.toggle({
            message: error.message,
            buttons: [
                new ErrorButtonHandler("Cancel", () =>
                    dispatch.modal.toggle(initModalState)
                ),
            ],
        });
        return Promise.reject(error);
    }
);

export default axios;
